@if (productPageFacade.isProductPageRevampEnabled) {
<h-product-template [product]="product">
    <ng-container selector>
        @if(product?.variants?.watchSizes || product?.variants?.strapColors || product?.variants?.strapLengths) {
        <h-watch-product-selector [product]="product"></h-watch-product-selector>
        } @if(!(product?.variants?.watchSizes || product?.variants?.strapColors || product?.variants?.strapLengths)) {

        <h-simple-product-selector [product]="product"></h-simple-product-selector>
        }
    </ng-container>
</h-product-template>
} @else {
<h-two-columns>
    <!-- right zone on desktop -->
    <ng-container ngProjectAs="[leftColumn]">
        <div class="product-infos-inner">
            @if (isServer || !isMobile) {

            <h-product-info-header class="desktop-only" [product]="product"> </h-product-info-header>

            }

            <section class="product-infos-content" [attr.aria-labelledby]="'product-info'">
                <span
                    hSrOnlyNoSnippet
                    id="product-info"
                    role="heading"
                    i18n-role
                    aria-level="2"
                    i18n="@@hermes.commerce.product_locator.product_information.label">
                    Product information
                </span>

                @if (isServer || isMobile) {

                <div class="product-image-carousel">
                    <h-carousel
                        class="mobile-only"
                        [isMobile]="isMobile"
                        [isLoopEnabled]="!isMobile"
                        [wrapAssetInsideButton]="true"
                        [assets]="carouselAssets$ | async"
                        [carouselTitle]="product.slug"
                        [videoControlPosition]="isVtoEnabled ? highPosition : lowPosition"
                        [controlSize]="controlSize"
                        [slideTo]="resetToFirstSlide$ | async"
                        [isControlsDisplayed]="!isMobile"
                        [imageFetchPriority]="true"
                        (slideChanged)="handleSlideChange($event)"
                        (clickOnAsset)="openZoomModal($event)">
                        <span
                            role="heading"
                            i18n-role
                            aria-level="2"
                            i18n="@@hermes.accessibility.product-images-gallery-title"
                            class="simple-product-title">
                            Image gallery
                        </span>
                    </h-carousel>
                    @if (isVtoEnabled && isMobile) {
                    <h-virtual-try-on-button id="virtual-try-on-button" [pageType]="'single product page'">
                    </h-virtual-try-on-button>
                    }
                </div>
                <h-product-info-header class="mobile-only" [attr.aria-hidden]="'true'" [product]="product">
                </h-product-info-header>

                } @if ( product?.variants?.watchSizes || product?.variants?.strapColors ||
                product?.variants?.strapLengths) {
                <h-watch-product-selector [product]="product"> </h-watch-product-selector>
                } @else {

                <h-simple-product-selector [product]="product"> </h-simple-product-selector>

                }

                <h-product-info-attributes [product]="product"></h-product-info-attributes>
                <div>
                    @if (product?.content?.toggles) {
                    <h-product-toggles
                        [productToggles]="product.content.toggles"
                        (expandToggle)="onExpandToggle($event)"></h-product-toggles>
                    }
                    <h-product-info-footer
                        [productReference]="product.sku"
                        [isComposite]="false"
                        [agecLinks]="product.agecLinks"></h-product-info-footer>
                </div>
            </section>
        </div>
    </ng-container>

    <!-- left zone on desktop -->
    <ng-container ngProjectAs="[rightColumn]">
        <!--image for desktop -->
        <div class="product-image">
            @if (isServer || !isMobile) {
            <h-product-image class="desktop-only" [product]="product" [isVtoEnabled]="isVtoEnabled">
                <span
                    hSrOnlyNoSnippet
                    id="tab-image-gallery"
                    role="heading"
                    i18n-role
                    aria-level="2"
                    i18n="@@hermes.accessibility.product-images-gallery-title">
                    Image gallery
                </span>
            </h-product-image>
            }
        </div>

        @if (product?.content?.storyBehind) {
        <div class="product-story-behind">
            <h-story-behind [storyBehind]="product.content.storyBehind"></h-story-behind>
        </div>
        }

        <h-product-page-cross-sell></h-product-page-cross-sell>
    </ng-container>
</h-two-columns>
}
